import { render } from "./EditSessionActivityDialog.vue?vue&type=template&id=be5763d8"
import script from "./EditSessionActivityDialog.vue?vue&type=script&lang=js"
export * from "./EditSessionActivityDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__